const InteractiveFeatures = () => {
  return (
    <>
      <div className='bg-white text-center dark:bg-jacarta-700'>
        <h1 className='pt-12 font-display text-3xl text-jacarta-700 dark:text-white'>
          Interactive Features
        </h1>
      </div>
      <div className='bg-white p-4 dark:bg-jacarta-700 md:flex'>
        <div className='m-2 lg:w-1/2'>
          <div className='rounded-2.5xl h-full border-solid bg-white p-12 dark:bg-jacarta-700'>
            <h2 className='mb-5 font-display text-2xl text-jacarta-700 dark:text-white'>
              Lending and Borrowing
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              Users borrow and lend their NFTs among themselves according to their needs and
              conditions. In this way, your collection becomes more interactive between users.
            </p>
            <h2 className='mb-5 font-display text-lg text-jacarta-700 dark:text-white'>
              What is Lending/Borrowing?
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              <span className='font-bold'>Borrowing</span> is the process of borrowing from other
              users by temporarily pledging their NFTs as collateral. <br /> <br />
              <span className='font-bold'>Lending</span> is a transaction in which lenders lend
              money to borrowers at a certain interest rate and earn interest at the end of the
              transaction.
            </p>
            <h2 className='mb-5 font-display text-lg text-jacarta-700 dark:text-white'>
              How does it work?
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              The borrower places an NFT in an advertisement for a certain amount and specifies the
              interest rate, duration, etc. that it is willing to pay. The Lender bids on the NFT
              with or without modification if it wants to change the conditions. The transaction
              takes place when the Borrower accepts the offer. If the borrower does not payback
              within the specified period, the lender can liqudiate the NFT.
            </p>
            <a
              href='https://lending.bit5.com/'
              target='_blank'
              className='inline-block rounded-full bg-accent px-8 py-3 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark'
              rel='noreferrer'
            >
              Go to Lending
            </a>
          </div>
        </div>
        {/* End What’s your DAO Idea?
  Let’s chat. */}
        <div className='m-2 lg:w-1/2'>
          <div className='rounded-2.5xl bg-white p-12 dark:bg-jacarta-700'>
            <h2 className='mb-5 font-display text-2xl text-jacarta-700 dark:text-white'>Voting</h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              To engage with your collection's community, you can see what NFT owners think on any
              given topic using the voting feature where we use snapshot infrastructure. Currently,
              we provide this feature as single choice with ERC721 type collections.
            </p>
            <h2 className='mb-5 font-display text-lg text-jacarta-700 dark:text-white'>
              What is Vote?
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              Vote, a collection is a system where the community can express their opinion on any
              topic, showing the opinion of the community in percentages.
            </p>
            <h2 className='mb-5 font-display text-lg text-jacarta-700 dark:text-white'>
              How to activate the Vote feature for a collection?
            </h2>
            <p className='mb-8 text-lg leading-normal dark:text-jacarta-300'>
              The fastest method for this is to create an ENS domain. Have a domain on snapshot.org
              with ENS domain and then contact us by filling out the voting application form to turn
              on the voting feature for your collection. You can vote according to the strategies we
              specify.
            </p>
            <a
              href='https://docs.google.com/forms/d/e/1FAIpQLSevjGITAz7ZGJ8ozw2t0IXabsJ0wRa7xO9aa8VFId_-cOrDTA/viewform?usp=sf_link'
              target='_blank'
              className='inline-block rounded-full bg-accent px-8 py-3 text-center font-semibold text-white shadow-accent-volume transition-all hover:bg-accent-dark'
              rel='noreferrer'
            >
              Contact Us
            </a>
          </div>
        </div>
        {/* End A global distributed community */}
      </div>
    </>
  );
};

export default InteractiveFeatures;
